<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="time">
<g id="Vector">
<path d="M12.5 6.64941C12.5 6.37327 12.2761 6.14941 12 6.14941C11.7239 6.14941 11.5 6.37327 11.5 6.64941V12.5382C11.5 12.6708 11.5527 12.798 11.6464 12.8917L14.0993 15.3446C14.2946 15.5399 14.6112 15.5399 14.8065 15.3446C15.0017 15.1494 15.0017 14.8328 14.8065 14.6375L12.5 12.3311V6.64941Z" fill="#212328"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z" fill="#212328"/>
</g>
</g>
</svg>
